var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"job-question-page"},[_c('QuestionForm',{ref:"questionForm",staticClass:"question-page",attrs:{"formLine":_vm.questionFormLine,"data":_vm.questionData,"presentation":"candidate-mobile"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }